const article = {
	slug: "singapore-front-row-seat",
	title: "Come for a Front Row Seat",
	date: "June 2026",
	updated: null,
	description: "A conversation with a Singapore Economic Development Board leader reframed Southeast Asia as the brightest growth spot globally, and questioned the assumption that New York is the center of gravity.",
	keywords: ["Southeast Asia", "global talent", "career growth", "Singapore"],
	tldr: "Southeast Asia's growth is a front row seat, not a lifestyle upgrade. The assumption that opportunity centers on one city is worth questioning.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, June 2026.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	hero: {
		src: "/articles-media/singapore-front-row-seat.jpeg",
		alt: "Singapore Economic Development Board leader presenting to a room in New York",
		caption: "The EDB's global-talent lead, presenting in New York.",
	},
	markdown: `I assumed the conversation would be about Singapore tech.

I was wrong.

A Deputy Executive Director of Singapore's Economic Development Board flew in from Singapore for an evening in New York. She runs the government's platform for global talent, with 19 years at the board behind her.

She was not there to pitch Singaporeans on coming home. She was talking to the rest of us.

Singapore has 1.6 vacancies for every job seeker right now. Southeast Asia has 700 million people, a rising middle class, and more multinationals setting up regional headquarters every year.

Her framing: "Come for a front row seat."

Not a lifestyle upgrade. A front row seat to what she called the brightest growth spot globally.

I have spent 15 years at the intersection of AI and financial services. The assumption has always been that the center of gravity is here in New York.

She made me question that.`,
};

export default article;
